export default __webpack_public_path__ + "static/media/lisieux11.9e1c930b.jpg";